import { TrashIcon } from "@heroicons/react/outline"
import { get } from "lodash"
import React, { useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { toast } from "react-toastify"
import { EndpointConfig } from "../../config"
import { AuthContext } from "../../context/auth.context"
import { axiosInstance } from "../../lib/axios"
import Button from "../atoms/button.atom"
import Loader from "../loader/loader.component"
import { parseStringTemplate, flatten } from "../template-info/templateUtils"

function WhatsAppDeal() {
	const { auth, setAuth } = useContext(AuthContext)
	const [btnLoading, setBtnLoading] = useState(false)
	const [loader, setLoader] = useState(false)
	const [selectedDeal, setSelectedDeal] = useState({})
	const [selectedContact, setSelectedContact] = useState([])
	const [serverTemplates, setServerTemplates] = useState([])
	const [currentTemplate, setCurrentTemplate] = useState({})

	const getDeal = (query, hubId) => {
		return axiosInstance.get(EndpointConfig.hubAppDeal + `/${query}`, {
			headers: { "hub-id": hubId }
		})
	}

	const getTemplates = (hubId) => {
		return axiosInstance.get(EndpointConfig.VFWhatsAppTemplates + "?filter=Deals", {
			headers: { "hub-id": hubId }
		})
	}

	const getMultipleContact = (contactList, hubId) => {
		return axiosInstance.get(EndpointConfig.hubAppMultipleContacts + `?ids=${contactList}`, {
			headers: { "hub-id": hubId }
		})
	}

	const removeSelectedContact = ({ hs_object_id }) => {
		setSelectedContact(selectedContact.filter(({ hs_object_id: id }) => id !== hs_object_id))
	}

	const getTemplatePreview = ({ templateText, variablesFlatten }) => {
		try {
			return parseStringTemplate(templateText, variablesFlatten)
		} catch (err) {
			console.error(err)
			return templateText
		}
	}

	const getPlacehoder = (str, obj) => {
		const placeholders = []
		str.split("{{").map((s) => {
			const varSplit = s.split("}}")
			if (varSplit.length === 2) {
				const value = obj[varSplit[0]]
				placeholders.push(value || " ")
			}
		})
		return placeholders
	}

	const sendMessage = () => {
		if (!(selectedContact && selectedContact.length > 0)) {
			toast("Please select at least one contact")
			return
		}
		setBtnLoading(true)
		;(async () => {
			const reqContact = selectedContact.map((cont) => {
				const contVariablesFlattenDeal = flatten("deals", selectedDeal)
				const contVariablesFlattenContact = flatten("contact", cont)
				const contVariablesFlatten = {
					...contVariablesFlattenDeal,
					...contVariablesFlattenContact
				}

				const formattedtext = getTemplatePreview({
					templateText: currentTemplate.templatetext,
					variablesFlatten: contVariablesFlatten
				})

				const placeholders = getPlacehoder(
					currentTemplate.templatetext,
					contVariablesFlatten
				)

				return {
					phone: cont.properties.phone.value,
					text: formattedtext,
					placeholders,
					hs_object_id: cont.vid
				}
			})
			await axiosInstance.post(
				EndpointConfig.VFSendWhatsApp,
				{
					contacts: reqContact,
					templateId: currentTemplate.templateid,
					module: "DEAL"
				},
				{ headers: { "hub-id": hubId } }
			)

			toast("Message Sent")
		})()
			.catch((err) => {
				console.log("🚀 ~ sendMessage ~ err", err)

				if (err?.response?.data?.message) {
					toast(err.response.data.message)
				} else {
					toast("Something Went Wrong")
				}
			})
			.finally(() => setBtnLoading(false))
	}

	const location = useLocation()

	useEffect(() => {
		const urlSearchParam = new URLSearchParams(location.search)
		const hubspotDetails = {}
		for (const [key, value] of urlSearchParam) {
			hubspotDetails[key] = value
		}

		setAuth({ hubId: hubspotDetails.hubId })

		if (hubspotDetails.hs_object_id) {
			init(hubspotDetails.hs_object_id, hubspotDetails.hubId)
		}
	}, [])

	const init = async (dealId, hubId) => {
		try {
			setLoader(true)
			const { data: dealData } = await getDeal(dealId, hubId)
			setSelectedDeal(dealData)

			const associatedVids = dealData?.associations?.associatedVids

			if (associatedVids && associatedVids.length > 0) {
				const { data: contactData } = await getMultipleContact(
					associatedVids.join(","),
					hubId
				)

				const filterContact = contactData.filter((cont) => cont?.properties?.phone?.value)

				setSelectedContact(filterContact)

				const { data: templateData } = await getTemplates(hubId)
				setServerTemplates(templateData)
			} else {
				toast("No contacts assicated with deal")
			}
		} catch (error) {
			console.log("🚀 ~ deal ~ init ~ error", error)
			toast("Something Went Wrong")
		} finally {
			setLoader(false)
		}
	}

	const hubId = auth.hubId

	return (
		<>
			{hubId && (
				<>
					<div className="flex flex-col">
						<div className="my-2"></div>
						<div className="flex flex-row items-center justify-center">
							<div className="flex flex-col items-center justify-center h-60">
								{loader && <Loader />}

								{selectedDeal && !loader && (
									<div className="flex flex-col flex-1 p-4 bg-white rounded w-700">
										<label className="text-xs text-gray-500 uppercase">
											Selected Deal :{" "}
											{selectedDeal?.properties?.dealname?.value}
										</label>
										{selectedContact.length > 0 && (
											<>
												<div className="flex flex-row flex-wrap gap-2 mt-1 mb-3">
													{selectedContact.map((cont, index) => {
														return (
															<div
																key={index}
																className="flex flex-row p-1 px-3 text-xs bg-gray-200 rounded-full"
															>
																<span className="mr-2">
																	{
																		cont?.properties?.firstname
																			?.value
																	}{" "}
																	:{" "}
																	{cont?.properties?.phone?.value}
																</span>
																<TrashIcon
																	className="w-4 h-4 text-gray-500 cursor-pointer"
																	onClick={() =>
																		removeSelectedContact(cont)
																	}
																/>
															</div>
														)
													})}
												</div>
												<label className="mt-4 text-xs text-gray-500 uppercase">
													Choose WhatsApp template
												</label>
												<select
													className="w-full px-2 py-1 text-sm border border-solid border-blue"
													value={currentTemplate?.templateid}
													onChange={(e) => {
														setCurrentTemplate(
															serverTemplates.find(
																(t) =>
																	t.templateid === e.target.value
															) || {}
														)
													}}
												>
													<option>Select</option>
													{serverTemplates.map((template) => (
														<option
															key={template.templateid}
															value={template.templateid}
														>
															{template.name} -{" "}
															{template.templatename}
														</option>
													))}
												</select>

												{currentTemplate?.templateid && (
													<div className="flex flex-col my-4 mt-8">
														<label className="text-xs text-gray-500 uppercase">
															Template Text
														</label>
														<div className="mb-2">
															{currentTemplate.templatetext}
														</div>

														<p className="mt-4 text-xs text-gray-400">
															This message will sent via Sender Phone:{" "}
															<b>{currentTemplate.senderPhone}</b>
														</p>

														<div className="flex flex-row gap-6">
															<div className="flex-[3]">&nbsp;</div>
															<div className="flex-1">
																&nbsp;
																{btnLoading ? (
																	<Button className="text-black bg-red-100 pointer-events-none">
																		Loading
																	</Button>
																) : (
																	<Button
																		className="w-full"
																		onClick={sendMessage}
																	>
																		Send Message
																	</Button>
																)}
															</div>
														</div>
													</div>
												)}
											</>
										)}
									</div>
								)}
							</div>
						</div>
					</div>
				</>
			)}
		</>
	)
}

export default WhatsAppDeal
